import React from 'react'
import reactStamp from 'react-stamp'
import req from 'reqwest';
import CircularProgress from 'material-ui/CircularProgress';
import Home from '../components/Home'
import TestPatient from 'json!../../www/resources/patient-info-portal-response.json'
import TestPractitioner from 'json!../../www/resources/practitioner-portal-response.json'

export default reactStamp(React).compose({

    init(){
        this.getBasicPatientInfo();
        this.handleSubmit = this.handleSubmit.bind(this);
    },

    state: {},

    render() {

        const styles = {
            loader: {
                textAlign: "center",
                marginTop: "30%",
                width: "100%"
            }
        }

        return ((this.state.info === undefined) || (this.state.info == "")) ?
            <CircularProgress style={styles.loader} size={2}/> :
            <Home
                patientNameGiven={this.state.info.name.given || ""}
                patientNameFamily={this.state.info.name.family || ""}
                patientAddressLine={this.state.info.address.line || ""}
                patientAddressCity={this.state.info.address.city || ""}
                patientAddressState={this.state.info.address.state || ""}
                patientAddressPostalCode={this.state.info.address.postalCode || ""}
                patientAddressCountry={this.state.info.address.country || ""}
                patientPhone={this.state.info.phone || ""}
                handleSubmit={this.handleSubmit}

                practitioner={this.state.practitioner || ""}
                src={this.state.photoSrc}
            />
    },

    getBasicPatientInfo(){
        let id = sessionStorage.getItem("id");
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/info",
            method: 'GET',
            crossOrigin: true,
            credentials: true
        })
            .then((resp)=> {
                this.handleGetPatientInfoResponse(resp)
            })
            .fail((err, msg) => this.handleGetPatientInfoError(err, msg))
            .always((resp) => {
            })
    },

    handleGetPatientInfoResponse(resp){
        this.setState({info: resp}, ()=> {
            this.props.setName(this.state.info.name.given + " " + this.state.info.name.family);
            this.getPrimaryCareProviderInfo(this.state.info.careProvider);
            switch (this.state.info.gender) {
                case "female":
                    this.setState({photoSrc: "resources/img/anna-pic.png"})
                    break;
                case "male":
                    this.setState({photoSrc: "resources/img/mike-pic.png"})
                    break;
                default:
                    this.setState({photoSrc: "resources/img/mason-pic.png"})
                    break;
            }
        });

    },

    handleGetPatientInfoError(err, msg){
    },

    putBasicPatientInfo(data){
        let id = sessionStorage.getItem("id");
        req({
            url: "https://portal-experience-api.cloudhub.io/api/patient/" + id + "/info",
            method: 'PUT',
            contentType: "application/json",
            crossOrigin: true,
            data: JSON.stringify(data)
        })
            .then((resp)=>this.handlePutPatientInfoResponse(resp))
            .fail((err, msg) => this.handlePutPatientInfoError(err, msg))
            .always((resp) => {
            })
    },

    handlePutPatientInfoResponse(resp){
        console.log(resp)
    },

    handlePutPatientInfoError(err, msg){
    },

    getPrimaryCareProviderInfo(id){
        req({
            url: "https://portal-experience-api.cloudhub.io/api/practitioners/" + id,
            method: 'GET',
            crossOrigin: true,
        })
            .then((resp) => this.handleGetProviderResponse(resp))
            .fail((err, msg) => this.handleGetProviderError(err, msg))
            .always((resp) => {
            })
    },

    handleGetProviderResponse(resp){
        this.setState({practitioner: resp})
    },

    handleGetProviderError(err, msg){
    },

    handleSubmit(line, city, state, postalCode, country, phone){
        let info = this.state.info;

        info.address.line = line;
        info.address.city = city;
        info.address.state = state;
        info.address.postalCode = postalCode;
        info.address.country = country;
        info.phone = phone;

        this.putBasicPatientInfo(info);

        this.setState({info: info});
    }

});


/** WEBPACK FOOTER **
 ** ./src/app/containers/Home.js
 **/